import React from "react";
import "./GuestCheckoutModal.css";

const GuestCheckoutModal = ({ isOpen, onClose, onContinueGuest, onLogin }) => {
  if (!isOpen) return null;

  return (
    <div className="checkout-modal-overlay">
      <div className="checkout-modal" style={{ maxWidth: "420px" }}>
        <div className="checkout-modal-top modal-top">
          <div></div>
          <button
            className="add-to-cart-button close-modal-button"
            onClick={onClose}
          >
            <i className="fas fa-times"></i>
          </button>
        </div>

        <h2 className="checkout-heading"></h2>

        <p style={{ lineHeight: "1.5" }}>
          Sign up to track orders, reorder fast, and get promo updates.
        </p>

        <div className="auth-buttons" style={{ display: "flex", gap: "10px", marginTop: "18px", flexWrap: "wrap" }}>
          <button
            className="add-to-cart-button auth-button"
            onClick={onLogin}
          >
            Login / Sign Up
          </button>

          <button
            className="add-to-cart-button auth-button"
            onClick={onContinueGuest}
            style={{ background: "#f3f3f3", color: "#000" }}
          >
            Continue as guest
          </button>
        </div>
      </div>
    </div>
  );
};

export default GuestCheckoutModal;